import { render } from "./modalTeam.vue?vue&type=template&id=6eefa72a"
import script from "./modalTeam.vue?vue&type=script&lang=js"
export * from "./modalTeam.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__